
import { useLeadStore } from './store/useLeadStore';
import { WidgetContainer } from './components/Layout/WidgetContainer';
import { Step1ClasseActif } from './components/Steps/Step1ClasseActif';
import { Step2TypeEstimation } from './components/Steps/Step2TypeEstimation';
import { Step3DetailsBien } from './components/Steps/Step3DetailsBien';
import { Step4UserProfile } from './components/Steps/Step4UserProfile';
import { Step5Contact } from './components/Steps/Step5Contact';
import { StepSuccess } from './components/Steps/StepSuccess';

function App() {
  const { currentStep } = useLeadStore();

  const renderStep = () => {
    switch (currentStep) {
      case 1:
        return <Step1ClasseActif />;
      case 2:
        return <Step2TypeEstimation />;
      case 3:
        return <Step3DetailsBien />;
      case 4:
        return <Step4UserProfile />;
      case 5:
        return <Step5Contact />;
      case 6:
        return <StepSuccess />;
      default:
        return <Step1ClasseActif />;
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center p-5">
      <WidgetContainer>{renderStep()}</WidgetContainer>
    </div>
  );
}

export default App;
